import { render, staticRenderFns } from "./PromptTrackAndTrace.vue?vue&type=template&id=f5de9c6e&scoped=true"
import script from "./PromptTrackAndTrace.vue?vue&type=script&lang=js"
export * from "./PromptTrackAndTrace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5de9c6e",
  null
  
)

export default component.exports